import { useAtomValue } from "jotai";

import { cn } from "@design-lab/shared";
import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import {
  useShowEditToolsAiImageRefinement,
  useShowNegativeSpaceAutomation
} from "@design-lab/shared/lib/config";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@design-lab/shared/ui/tabs";

import { aiRefineGeneratingAtom } from "../../model/state";

type RefineToolTabsProps = {
  activeTool: string;
  onToolChange: (tool: string) => void;
};

export function RefineToolTabs({ activeTool, onToolChange }: RefineToolTabsProps) {
  const isGenerating = useAtomValue(aiRefineGeneratingAtom);
  const { isDesktop } = useResponsive();
  const shouldShowNegativeSpaceTool = useShowNegativeSpaceAutomation();
  const shouldShowAiRefineToolFeature = useShowEditToolsAiImageRefinement();

  const showNegativeSpace = shouldShowNegativeSpaceTool;

  // Show tabs if either negative space or AI refine is enabled
  if (!showNegativeSpace && !shouldShowAiRefineToolFeature) return null;

  return (
    <div className="lg:top-18 absolute left-1/2 top-16 z-10 w-[92%] max-w-3xl -translate-x-1/2">
      <Tabs value={activeTool} onValueChange={onToolChange}>
        <TabsList className="bg-white shadow-lg">
          <TabsTrigger
            data-testid="refine-tab-erase"
            value="erase"
            className={cn(
              "text-gray-700 data-[state=active]:bg-blue-700 data-[state=active]:text-white",
              !isDesktop && "text-xs"
            )}
            disabled={isGenerating}
          >
            Erase
          </TabsTrigger>
          {showNegativeSpace && (
            <TabsTrigger
              data-testid="refine-tab-negative"
              value="negative"
              className={cn(
                "text-gray-700 data-[state=active]:bg-blue-700 data-[state=active]:text-white",
                !isDesktop && "text-xs"
              )}
              disabled={isGenerating}
            >
              Color Removal
            </TabsTrigger>
          )}
          {shouldShowAiRefineToolFeature && (
            <TabsTrigger
              data-testid="refine-tab-ai"
              value="refine"
              className={cn(
                "text-gray-700 data-[state=active]:bg-blue-700 data-[state=active]:text-white",
                !isDesktop && "text-xs"
              )}
            >
              Edit Artwork
            </TabsTrigger>
          )}
        </TabsList>
        <TabsContent value="erase" />
        <TabsContent value="negative" />
        <TabsContent value="refine" />
      </Tabs>
    </div>
  );
}
